import { QualitySettings } from "app/player/consts"
import { getPlayerThickIcon } from "app/player/getPlayerThickIcon"
import { FileVariantType } from "db/enums"
import { currentOpenPopoverAtom } from "app/player/state"
import { Value } from "@stringtale/react"
import { useAtom } from "jotai"
import { ComponentProps, Dispatch, SetStateAction } from "react"
import PlayerIcon from "./PlayerIcon"
import PlayerOptionModal from "./PlayerOptionModal"
import PlayerDropdownOptions from "./PlayerDropdownOptions"

export default function PlayerQualityDropDown({
  options,
  setOption,
  selectedOption,
  size,
  triggerColor = "blue",
}: {
  options: { type: FileVariantType }[]
  setOption: Dispatch<SetStateAction<FileVariantType>>
  selectedOption: FileVariantType
  size?: ComponentProps<typeof PlayerOptionModal>["triggerSize"]
  triggerColor?: ComponentProps<typeof PlayerOptionModal>["triggerColor"]
}) {
  const [openMenu, setOpenMenu] = useAtom(currentOpenPopoverAtom)

  return (
    <PlayerOptionModal
      title={
        <Value name="apps.web.src.video-slides.components.player.playerqualitydropdown.afspeelkwaliteit">
          Afspeelkwaliteit
        </Value>
      }
      menuWidth={270}
      icon={
        <PlayerIcon
          src={getPlayerThickIcon(triggerColor ?? "blue", "ico_settings.svg")}
          size={18}
        />
      }
      activeIcon={
        <PlayerIcon
          src="/icons/player/thick/ico_settings_active.svg"
          size={18}
        />
      }
      triggerColor={triggerColor}
      triggerSize={size}
      open={openMenu === "quality"}
      onOpenChange={(val) => {
        setOpenMenu((prev) =>
          val ? "quality" : prev === "quality" ? null : prev
        )
      }}
    >
      <PlayerDropdownOptions
        data={
          QualitySettings as {
            type: FileVariantType
            text: string
            subText?: string
            chevron?: boolean
          }[]
        }
        options={options}
        setOption={setOption}
        selectedOption={selectedOption}
        onOptionSelect={() => setOpenMenu(null)}
      />
    </PlayerOptionModal>
  )
}
